var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../../utils/serializr/schema/middle/withDefault';
import { primitive } from '../../../../utils/serializr/schema/inner/primitive';
import { editable, editObservable } from '../../../../utils/mobx/decorators/editable';
export class TopicStore {
    parent;
    previewHtml;
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get topic() {
        return this.parent;
    }
    static get serializeInfo() {
        return {
            props: {
                previewHtml: withDefault(primitive, ''),
            },
        };
    }
}
__decorate([
    editable()
], TopicStore.prototype, "previewHtml", void 0);
__decorate([
    memoize
], TopicStore, "serializeInfo", null);
